import { render, staticRenderFns } from "./ArticlesPage.vue?vue&type=template&id=63d217d4&"
import script from "./ArticlesPage.vue?vue&type=script&lang=js&"
export * from "./ArticlesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleList: require('/vercel/path0/components/articles/ArticleList.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default,ComponentLoader: require('/vercel/path0/components/general/ComponentLoader.vue').default})
